import Pager from "./Pager";

function PagerController() {
    this.constructor = PagerController;
}

/**
 * @param conf must has fields:
 *      .pagerData.pageNum
 *      .pagerData.recordsPerPage
 *      .pagerData.totalRecords
 *      .handlersMap.pageChanged (function(pageNum){})
 *      .handlersMap.recordsPerPageChanged (function(recordsPerPage){})
 *      .pagerControlsElementId
 *      .pagerElementId
 *      .recordsPerPageSelectorId
 *      .minRecordsPerPage
 *      .ignoreHashChange
 */
PagerController.prototype.init = function({
    pagerData = {
        pageNum: 1,
        recordsPerPage: 1,
        totalRecords: 1,
    },
    pagerControlsElementId = '',
    pagerControlsElement = null,
    minRecordsPerPage = 1,
    pagerElementId = '',
    pagerElement = null,
    handlersMap = {
        pageChanged: () => {},
        recordsPerPageChanged: () => {},
    },
    locationHashString = '',
    ignoreHashChange = false,
    recordsPerPageSelectorId = '',
    recordsPerPageSelectorElement = null,
}) {
    this.pageNum = pagerData.pageNum;
    this.recordsPerPage = pagerData.recordsPerPage;
    // validate records per page
    if (this.recordsPerPage < 1) {
        console.warn("Incorrect records per page value: " + this.recordsPerPage);
    }
    this.totalRecords = pagerData.totalRecords;
    this.pagerData = pagerData;
    if (pagerControlsElement !== null) {
        this.pagerControlsElement = pagerControlsElement
    } else {
        this.pagerControlsElement = document.getElementById(pagerControlsElementId);
    }
    this.minRecordsPerPage = minRecordsPerPage;

    let pagerContentEl
    if (pagerElement !== null) {
        pagerContentEl = pagerElement
    } else {
        pagerContentEl = document.getElementById(pagerElementId);
    }
    this.pager = new Pager(pagerContentEl, "&nbsp;", "&nbsp;", "...", handlersMap.pageChanged, locationHashString, ignoreHashChange);

    var self = this;
    if (recordsPerPageSelectorElement !== null) {
        this.recordsPerPageSelector = recordsPerPageSelectorElement
    } else {
        this.recordsPerPageSelector = document.getElementById(recordsPerPageSelectorId);
    }
    this.recordsPerPageSelector.value = this.recordsPerPage;
    this.recordsPerPageSelector.onchange = function() {
        handlersMap.recordsPerPageChanged(self.recordsPerPageSelector.value);
    };

    return this;
};

PagerController.prototype.renderThisController = function() {
    this.render();
};


PagerController.prototype.getPageNum = function() {
    return this.pageNum;
};

PagerController.prototype.getTotalPages = function() {
    return Pager.getTotalPages(this.totalRecords, this.recordsPerPage);
};

PagerController.prototype.getTotalRecords = function() {
    return this.totalRecords;
};

PagerController.prototype.getRecordsPerPage = function() {
    return this.recordsPerPage;
};

PagerController.prototype.render = function() {
    if (this.totalRecords > this.minRecordsPerPage) {
        this.setRecordsPerPage(this.recordsPerPage);
        this.pagerControlsElement.style.display = "table";

        if (this.getTotalPages() > 1)
            this.pager.draw(this.totalRecords, this.recordsPerPage, this.pageNum);
        else
            this.pager.remove();
    } else {
        this.pagerControlsElement.style.display = "none";
    }
};

PagerController.prototype.setRecordsPerPage = function(value) {
    this.recordsPerPageSelector.value = value;
};

PagerController.prototype.setPagerStateAndUpdateUI = function(totalRecords, pageNum, recordsPerPage) {
    this.totalRecords = totalRecords;
    this.pageNum = pageNum;
    this.recordsPerPage = recordsPerPage;
    this.render();
};

PagerController.prototype.loadPage = function(pageNum) {
    this.pager.loadPage(pageNum);
};

PagerController.prototype.reloadEmptyPage = function() {
    if (this.getTotalPages() == this.getPageNum() && this.getTotalPages() > 1) {
        this.loadPage(this.getPageNum() - 1);
    } else {
        this.loadPage(this.getPageNum());
    }
};

export default PagerController;


// WEBPACK FOOTER //
// ./web/js/pager/PagerController.js